import CityPageTemplate from "../city-template/CityPageTemplate";
import { sheboyganConfig } from "./data";

export default function SheboyganPage() {
  return <CityPageTemplate config={sheboyganConfig} />;
}